export const SLIDES_DATA = [
  {
    id: 1,
    file_name: 'slide-one',
    identifier: 'slide-one',
  },
  {
    id: 2,
    file_name: 'slide-two',
    identifier: 'slide-two',
  },
  {
    id: 3,
    file_name: 'slide-three',
    identifier: 'slide-three',
  },
  {
    id: 4,
    file_name: 'slide-four',
    identifier: 'slide-four',
  },
  {
    id: 5,
    file_name: 'slide-five',
    identifier: 'slide-five',
  },
  {
    id: 6,
    file_name: 'slide-six',
    identifier: 'slide-six',
  },
];
